import React from 'react';
import OdooService from '../../services/OdooService';
import TitanDialog from '../Titan/TitanDialog';
import TitanDataGrid from '../TitanDataGrid/TitanDataGrid';
import useTitanDataGrid from '../TitanDataGrid/useTitanDataGrid';
import Link from '@mui/material/Link';

export default function SelectOdooManufacturingOrdersDialog({
  odooProductId,
  title,
  saveButtonLabel,
  multiSelect = false,
  onSelect,
  onClose
}) {
  const [
    selectedManufacturingOrders,
    setSelectedManufacturingOrders
  ] = React.useState([]);

  const loadData = React.useCallback(
    async ({ page, pageSize, search }, config) => {
      const params = {
        page: page,
        pageSize: pageSize
      };

      if (search) {
        params.search = search;
      }

      if (odooProductId) {
        params.odooProductId = odooProductId;
      }

      const { data, pagination } = await OdooService.getOdooManufacturingOrders(
        params,
        config
      );

      return {
        data,
        page: pagination.page - 1,
        totalCount: pagination.totalCount
      };
    },
    []
  );

  const titanDataGridProps = useTitanDataGrid(loadData);

  const columns = React.useMemo(
    () => [
      {
        headerName: 'Odoo manufacturing order',
        field: 'name',
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
          <Link href={row.odooManufacturingOrderPageUrl} target="_blank">
            {row.name}
          </Link>
        )
      }
    ],
    []
  );

  return (
    <TitanDialog
      title={title}
      maxWidth="lg"
      onClose={onClose}
      onSave={() => onSelect(selectedManufacturingOrders[0])}
      cancelButtonLabel="Close"
      isValid={selectedManufacturingOrders.length > 0}
      saveButtonLabel={saveButtonLabel}
    >
      <TitanDataGrid
        searchPlaceholder="Search by Odoo Manufacturing Order name..."
        {...titanDataGridProps}
        columns={columns}
        onClose={onClose}
        onSelectionModelChange={selectedManufacturingOrders =>
          setSelectedManufacturingOrders(selectedManufacturingOrders)
        }
        selectedRows={selectedManufacturingOrders}
        checkboxSelection
        checkboxMultiSelection={multiSelect}
        isRowSelectable={({ row }) => !row.fpManufacturingOrderId}
      />
    </TitanDialog>
  );
}
